import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiSearchIcon from "@mui/icons-material/Search";
import MuiDeleteIcon from "@mui/icons-material/Delete";
import MuiTextField from "@mui/material/TextField";
import MuiFolderOpenIcon from "@mui/icons-material/FolderOpen";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelTeam from "../../model/custom/Team";
import ControllerTeamList from "../../controller/custom/TeamList";
import ControllerUserList from "../../controller/UserList";
import ControllerLocalization from "../../controller/Localization";
import ViewLoader from "../Loader";
import ViewPagination from "../Pagination";
import ViewDialog from "../Dialog";

let isRendered = false;

const teamListAutocompleteSlotProps = HelperSrc.createAutocompleteSlotProps("view_list_popper", [0, 0]);

const viewPageTeamList: React.FC<ModelTeam.Iprops> = (props) => {
    // Variable
    const controllerTeamList = new ControllerTeamList(isRendered);
    const controllerUserList = new ControllerUserList(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerTeamList.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (
        controllerLocalization.getStorageMain &&
        controllerTeamList.getSelectOption &&
        controllerTeamList.getPagination &&
        controllerTeamList.getFilter &&
        controllerTeamList.getDataMainList
    ) {
        return (
            <div className="view_team_list" data-at_id="view_team_list">
                <div className="button_container">
                    {(() => {
                        const html: JSX.Element[] = [];

                        if (HelperSrc.checkRole(controllerUserList.getStorageRole, ["superuser"], props.userData)) {
                            html.push(
                                <MuiButton
                                    className="button_primary"
                                    data-at_id="button_create_team"
                                    disabled={controllerTeamList.getApiLoadingList.selectOption}
                                    onClick={() => {
                                        controllerTeamList.clickCreate();
                                    }}
                                >
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        if (controllerTeamList.getApiLoadingList.selectOption) {
                                            html.push(<MuiCircularProgress className="icon_progress" />);
                                        } else {
                                            html.push(<>{controllerLocalization.getStorageMain.create}</>);
                                        }

                                        return html;
                                    })()}
                                </MuiButton>
                            );
                        }

                        return html;
                    })()}
                </div>
                <table>
                    {(() => {
                        const html: JSX.Element[] = [];

                        html.push(
                            <>
                                <colgroup>
                                    <col className="cell id" />
                                    <col className="cell team_name" />
                                    <col className="cell update_date" />
                                    <col className="cell update_by" />
                                    <col className="cell" />
                                </colgroup>
                                <thead className="filter">
                                    <tr className="row filter_action">
                                        <td>
                                            <MuiButton
                                                className="button_primary container_button"
                                                data-at_id="button_apply"
                                                disabled={controllerTeamList.getApiLoadingList.selectOption}
                                                onClick={() => {
                                                    controllerTeamList.clickFilterApply();
                                                }}
                                            >
                                                {(() => {
                                                    const html: JSX.Element[] = [];

                                                    if (controllerTeamList.getApiLoadingList.selectOption) {
                                                        html.push(<MuiCircularProgress className="icon_progress" />);
                                                    } else {
                                                        html.push(
                                                            <span className="button_label">
                                                                {controllerLocalization.getStorageMain.apply} <MuiSearchIcon />
                                                            </span>
                                                        );
                                                    }

                                                    return html;
                                                })()}
                                            </MuiButton>
                                        </td>
                                    </tr>
                                    <tr className="row not_hover">
                                        <th className="cell field_container">{controllerLocalization.getStorageMain.id}</th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={teamListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerTeamList.getSelectOption.name)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="name"
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.name : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={teamListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerTeamList.getSelectOption.latest_update)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li className="date" {...props}>
                                                                {option.display_name
                                                                    ? HelperSrc.localeFormat(new Date(option.display_name))
                                                                    : controllerLocalization.getStorageMain.select}
                                                            </li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        name="latest_update"
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.latest_update
                                                                : ""
                                                        }
                                                    />
                                                )}
                                            />
                                        </th>
                                        <th className="cell field_container">
                                            <MuiAutocomplete
                                                slotProps={teamListAutocompleteSlotProps}
                                                blurOnSelect
                                                options={(() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                    for (const optionData of Object.values(controllerTeamList.getSelectOption.user_id)) {
                                                        const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                        optionList.push(optionDataTyped);
                                                    }

                                                    return optionList;
                                                })()}
                                                getOptionLabel={(option) => option.display_name}
                                                renderOption={(props, option) => {
                                                    if (controllerLocalization.getStorageMain) {
                                                        return (
                                                            <li {...props}>{option.display_name || controllerLocalization.getStorageMain.select}</li>
                                                        );
                                                    }
                                                }}
                                                isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                                renderInput={(params) => (
                                                    <div>
                                                        <MuiTextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="field_value"
                                                            label={
                                                                controllerLocalization.getStorageMain
                                                                    ? controllerLocalization.getStorageMain.latest_update_by
                                                                    : ""
                                                            }
                                                        />
                                                        <input
                                                            type="hidden"
                                                            className="field_value"
                                                            name="latest_update_by_id"
                                                            defaultValue={controllerTeamList.getElementLatestUpdateByIdValue}
                                                        />
                                                    </div>
                                                )}
                                                onChange={(_, option) => {
                                                    if (option && controllerTeamList.setElementLatestUpdateByIdValue) {
                                                        controllerTeamList.setElementLatestUpdateByIdValue(option.value as string);
                                                    }
                                                }}
                                            />
                                        </th>
                                        <th className="cell field_container"></th>
                                    </tr>
                                </thead>
                            </>
                        );

                        return html;
                    })()}
                    <tbody data-at_id="tbody_team_list">
                        {(() => {
                            const html: JSX.Element[] = [];

                            if (controllerTeamList.getApiLoadingList.list) {
                                html.push(
                                    <tr className="row_empty">
                                        <td>
                                            <MuiCircularProgress className="icon_progress" />
                                        </td>
                                    </tr>
                                );
                            } else {
                                if (!controllerTeamList.getPagination || Object.entries(controllerTeamList.getPagination.data).length === 0) {
                                    html.push(
                                        <tr className="empty_state">
                                            <td colSpan={100}>
                                                <MuiFolderOpenIcon className="icon" />
                                                <p>{controllerLocalization.getStorageMain.no_result}</p>
                                            </td>
                                        </tr>
                                    );
                                } else {
                                    for (const [key, data] of Object.entries(controllerTeamList.getDataMainList)) {
                                        const alternateRow = Number(key) % 2 === 1 ? "even" : "";

                                        html.push(
                                            <tr
                                                className={`row ${alternateRow}`}
                                                data-at_id={`tr_list_data_${data.id}`}
                                                onClick={(event) => {
                                                    controllerTeamList.clickItem(event, data);
                                                }}
                                            >
                                                <td className="cell">{data.id}</td>
                                                <td className="cell" data-at_id="td_name">
                                                    {data.name}
                                                </td>
                                                <td className="cell">
                                                    {data.latest_update ? HelperSrc.localeFormat(new Date(data.latest_update)) : ""}
                                                </td>
                                                <td className="cell">
                                                    {(() => {
                                                        for (const optionData of Object.values(
                                                            controllerTeamList.getSelectOption.latest_update_by_id
                                                        )) {
                                                            const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                            if (data.latest_update_by_id === optionDataTyped.value) {
                                                                return optionDataTyped.display_name;
                                                            }
                                                        }
                                                    })()}
                                                </td>
                                                <td className="cell center">
                                                    {(() => {
                                                        const html: JSX.Element[] = [];

                                                        if (
                                                            HelperSrc.checkRole(
                                                                controllerUserList.getStorageRole,
                                                                ["superuser", "manager"],
                                                                props.userData
                                                            )
                                                        ) {
                                                            html.push(
                                                                <MuiDeleteIcon
                                                                    data-at_id="icon_delete"
                                                                    className="button_icon"
                                                                    onClick={(event) => controllerTeamList.clickRemove(event, data.id)}
                                                                />
                                                            );
                                                        }

                                                        return html;
                                                    })()}
                                                </td>
                                            </tr>
                                        );
                                    }
                                }
                            }

                            return html;
                        })()}
                    </tbody>
                </table>
                <ViewPagination response={controllerTeamList.getPagination} api={controllerTeamList.apiDataList} />
                <ViewDialog
                    className="team_remove_dialog"
                    isOpen={controllerTeamList.getIsDialogOpen}
                    isApiLoading={controllerTeamList.getApiLoadingList.removeData}
                    labelConfirm={controllerLocalization.getStorageMain.yes}
                    onClickConfirm={controllerTeamList.clickDialogRemoveConfirm}
                    labelCancel={controllerLocalization.getStorageMain.no}
                    onClickCancel={controllerTeamList.clickDialogRemoveCancel}
                    mode={"alert"}
                    content={controllerLocalization.getStorageMain.delete_record}
                />
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageTeamList;
